/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dataRouting.vue?vue&type=template&id=11b869e1"
import script from "./dataRouting.vue?vue&type=script&lang=js"
export * from "./dataRouting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports